export const getFileName = (url) =>
    url.split('/').pop().split('#')[0].split('?')[0];

export const getExtension = (url) =>
    url.split(/[#?]/)[0].split('.').pop().trim();

export const stripQueryStringAndHash = (url) => url.split('?')[0].split('#')[0];

export const isImage = (url) =>
    /\.(jpg|jpeg|png|webp|avif|gif|svg)$/i.test(stripQueryStringAndHash(url));

export const renameFileSuffix = (url) => {
    const name = getFileName(url);
    const [fileName, fileExtension] = name.split(/\.(?=[^\.]+$)/);
    if (!isNaN(fileName.slice(-1)) && /^(_\d)$/.test(fileName.slice(-2))) {
        return `${fileName.replace(
            /.$/,
            Number(fileName.slice(-1)) + 1,
        )}.${fileExtension}`;
    } else {
        return `${fileName}_1.${fileExtension}`;
    }
};
